import React, { Component } from "react";
import { Grid } from "@material-ui/core";
import team from "../img/3d/aboutus.png";
import Zoom2 from "react-reveal/Zoom";

class Nosotros extends Component {
  render() {
    document.addEventListener("DOMContentLoaded", () => {
      const root = document.documentElement;
      const marqueeElementsDisplayed = getComputedStyle(root).getPropertyValue(
        "--marquee-elements-displayed"
      );
      const marqueeContent = document.querySelector("ul.marquee-content");
      root.style.setProperty(
        "--marquee-elements",
        marqueeContent.children.length
      );
      for (let i = 0; i < marqueeElementsDisplayed; i++) {
        marqueeContent.appendChild(marqueeContent.children[i].cloneNode(true));
      }
    });
    return (
      <div className="nosotros" id={this.props.id}>
        <Grid
          container
          direction="row"
          justify="center"
          alignItems="stretch"
          style={{ height: "100vh" }}
          className="nosCont"
        >
          <Grid
            item
            container
            direction="column"
            justify="center"
            alignItems="center"
            xs={12}
            sm={7}
            className="nosIllus"
          >
            <Zoom2>
              <img src={team} alt="workteam" className="img-fluid"></img>
            </Zoom2>
          </Grid>
          <Grid
            item
            container
            direction="column"
            justify="center"
            alignItems="center"
            xs={12}
            sm={5}
            className="nosText"
          >
            <h1 id="h1nosotros">Conoce más de nosotros</h1>
            <p>
              En Time Lab contamos con un equipo multidisciplinario
              especializado y certificado en cada área de trabajo, la parte
              creativa, técnica, administrativa y marketing se juntan para
              brindar una mejor asistencia a nuestros clientes.
              <br />
              <br />
              Sin embargo, no pretendemos entregar simplemente un servicio,
              evaluamos cada proyecto detenidamente, nos involucramos en el
              mismo y proponemos las soluciones integrales más adecuadas para
              cumplir sus metas de forma personalizada.
            </p>
          </Grid>
        </Grid>
        <div className="marqueediv"></div>
        <div className="marquee">
          <ul className="marquee-content">
            <li>
              <i className="fab fa-github"></i>
            </li>
            <li>
              <i className="fab fa-react"></i>
            </li>
            <li>
              <i className="fab fa-vuejs"></i>
            </li>
            <li>
              <i className="fab fa-angular"></i>
            </li>
            <li>
              <i className="fab fa-node"></i>
            </li>
            <li>
              <i class="fab fa-js-square"></i>
            </li>
            <li>
              <i class="fab fa-laravel"></i>
            </li>
            <li>
              <i className="fab fa-wordpress"></i>
            </li>
            <li>
              <i className="fab fa-joomla"></i>
            </li>
            <li>
              <i className="fab fa-drupal"></i>
            </li>
            <li>
              <i class="fab fa-html5"></i>
            </li>
            <li>
              <i class="fab fa-css3-alt"></i>
            </li>
            <li>
              <i class="fab fa-bootstrap"></i>
            </li>
            <li>
              <i class="fab fa-sass"></i>
            </li>
            <li>
              <i class="fab fa-less"></i>
            </li>
            <li>
              <i class="fab fa-java"></i>
            </li>
            <li>
              <i class="fab fa-python"></i>
            </li>
            <li>
              <i class="fab fa-php"></i>
            </li>
          </ul>
        </div>
      </div>
    );
  }
}

export default Nosotros;
